var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.35714C0 0.607614 0.626801 0 1.4 0H26.6C27.3732 0 28 0.607614 28 1.35714C28 2.10667 27.3732 2.71429 26.6 2.71429H1.4C0.626801 2.71429 0 2.10667 0 1.35714ZM0 9.5C0 8.75047 0.626801 8.14286 1.4 8.14286H26.6C27.3732 8.14286 28 8.75047 28 9.5C28 10.2495 27.3732 10.8571 26.6 10.8571H1.4C0.626801 10.8571 0 10.2495 0 9.5ZM0 17.6429C0 16.8933 0.626801 16.2857 1.4 16.2857H26.6C27.3732 16.2857 28 16.8933 28 17.6429C28 18.3924 27.3732 19 26.6 19H1.4C0.626801 19 0 18.3924 0 17.6429Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBurger);
export default __webpack_public_path__ + "static/media/navBurger.5080338522e2cc4e7da12ee07f3cd4d2.svg";
export { ForwardRef as ReactComponent };